<script lang="ts">
	interface Props {
		isStart: boolean
		isEnd: boolean
		isFirst: boolean
		isLast: boolean
		isFirstInMonth: boolean
		isLastInMonth: boolean
		class?: string
	}

	let {
		isStart,
		isEnd,
		isFirst,
		isLast,
		isFirstInMonth,
		isLastInMonth,
		class: className = '',
	}: Props = $props()
</script>

{#if !isLast && !isLastInMonth && !isEnd}
	{#if isStart || (isFirst && !isFirstInMonth) || isFirstInMonth}
		<div class="absolute top-0 right-0 h-full w-1/2 {className}"></div>
	{/if}
{/if}
{#if !isFirst && !isStart && !isFirstInMonth}
	{#if isEnd || isLast || isLastInMonth}
		<div class="absolute top-0 left-0 h-full w-1/2 {className}"></div>
	{/if}
{/if}
